import { render } from "./SearchHeroSection.vue?vue&type=template&id=97fd1a34&scoped=true"
import script from "./SearchHeroSection.vue?vue&type=script&lang=js"
export * from "./SearchHeroSection.vue?vue&type=script&lang=js"

import "./SearchHeroSection.vue?vue&type=style&index=0&id=97fd1a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fd1a34"]])

export default __exports__